import React from 'react'
import Nabor from '../../Assets/images/don/listeat.jpg';
import Paynet from '../../Assets/images/don/donate.jpg';
import Check from '../../Assets/images/don/document.jpg';
import Howhelp from '../component/Howhelp';
import Contrate from '../../Assets/file/contract.pdf';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const Helpproject = () => {
  const { t } = useTranslation();
  
  return (
    <div className="test_block">
        <div className="container no_decor">
            <div className="row">
                <div className="col-lg-12">
                  <div className="help-method ">
                  <blockquote>
                  <p>{t('helpproject.quote')}</p>
                  <cite>{t('helpproject.author')}</cite>
                  </blockquote>
                  <p>{t('helpproject.paragraph1')}<br/>{t('helpproject.paragraph2')}</p>
                  <p>{t('helpproject.paragraph3')}</p>
                  <p>{t('helpproject.paragraph4')}</p>
                  </div>

                </div>
                <div className="col-lg-12">
                  <div className="contain-infor">
                    <h2>{t('helpproject.donateTitle')}</h2>
                  </div>
                </div>
                <div className="col-lg-4 mb2r">
                  <Link to="/">
                    <div className="contain-link">
                      <img src={Nabor} alt={t('helpproject.buyProducts')} />
                      <h3 className="main-donate__variables__title">{t('helpproject.buyProducts')}</h3>
                    </div>
                  </Link>
                </div>
                <div className="col-lg-4 mb2r">
                  <Link to="/donate" >
                    <div className="contain-link">
                      <img src={Paynet} alt={t('helpproject.oneTimeDonation')} />
                      <h3 className="main-donate__variables__title">{t('helpproject.oneTimeDonation')}</h3>
                    </div>
                  </Link>
                </div>
                <div className="col-lg-4 mb2r">
                  <a href={Contrate}>
                    <div className="contain-link">
                      <img src={Check} alt={t('helpproject.requisitesForLegalEntities')} />
                      <h3 className="main-donate__variables__title">{t('helpproject.requisitesForLegalEntities')}</h3>
                    </div>
                  </a>
                </div>
            </div>
            <Howhelp />
        </div>
    </div>
  )
}

export default Helpproject